import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import BrInputBox from '@components/BrInputBox';
import './BrProductSlotter.scss';

export const MSG_TYPE = { INFO: 0, ERROR: 1 };

/* eslint-disable react/no-array-index-key */
export const BrProductSlotter = (props) => {
  const {
    startPos,
    endPos,
    onInputChange,
    onGridItemClick,
    onCancel,
    onConfirm,
    currentItemIndex,
    title,
    confirmText,
    cancelText,
    limit,
    allowExceedLimit,
    exceedLimitGridClassName,
    msgGenerator,
    currProductList,
  } = props;
  const [selectedPosition, setSelectedPosition] = useState(currentItemIndex ? currentItemIndex + 1 : 1);
  const [userInput, setUserInput] = useState(currentItemIndex ? currentItemIndex + 1 : 1);
  const [error, setError] = useState();
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState(MSG_TYPE.INFO);
  const selectedGridItemRef = useRef();

  useEffect(() => {
    if (selectedGridItemRef.current) {
      selectedGridItemRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [selectedPosition]);

  useEffect(() => {
    if (msgGenerator) {
      const msgObj = msgGenerator(selectedPosition);
      setMessage(msgObj?.msg);
      setMessageType(msgObj?.msgType);
    }
  }, [selectedPosition, msgGenerator]);

  /* eslint-disable */
  const onEnterHandler = () => {
    if (userInput > endPos) {
      setError('Input position out of range');
    } else if (isNaN(userInput)) {
      setError('Enter a number');
    } else {
      setSelectedPosition(userInput);
    }
  };
  /* eslint-enable */

  const handleGridItemClick = (position) => {
    setUserInput(position);
    setSelectedPosition(position);
    if (onGridItemClick) {
      onGridItemClick(position);
    }
  };

  /* eslint-disable */
  const inputBoxChangeHandler = (e) => {
    if (error) {
      setError(null);
    }
    const position = Number(e.target.value);
    if (!isNaN(position)) {
      setUserInput(position);
    }
    if (onInputChange) {
      onInputChange(position);
    }
  };
  /* eslint-enable */

  const isPositionInRange = (position) => {
    if (limit && position <= limit) {
      return true;
    }
    if (!limit && position <= endPos) {
      return true;
    }
    return false;
  };

  const isPositionAllowedToExceedTill = (position) => {
    if (allowExceedLimit && position <= endPos) {
      return true;
    }
    return false;
  };

  /* eslint-disable */
  const getGridItemClassName = (position) => {
    const baseClass = 'product-slotter-grid-cell';
    if (Array.isArray(currProductList)) {
      const length = currProductList.length;
      if (position - selectedPosition < length && position - selectedPosition >= 0) {
        return cn(baseClass, 'selected');
      }
      if (isPositionInRange(position)) {
        return cn(baseClass, 'in-range');
      }
      if (
        selectedPosition > limit
        && position < selectedPosition
        && isPositionAllowedToExceedTill(position)
      ) {
        return cn(baseClass, exceedLimitGridClassName, 'exceed-limit');
      }
      return cn(baseClass, 'not-allowed');
    } else {
      if (position === selectedPosition) {
        return cn(baseClass, 'selected');
      }
      if (isPositionInRange(position)) {
        return cn(baseClass, 'in-range');
      }
      if (
        selectedPosition > limit
        && position < selectedPosition
        && isPositionAllowedToExceedTill(position)
      ) {
        return cn(baseClass, exceedLimitGridClassName, 'exceed-limit');
      }
      return cn(baseClass, 'not-allowed');
    }
  };
  /* eslint-enable */

  const getMessageClassName = () => {
    switch (messageType) {
      case MSG_TYPE.INFO:
        return 'info-msg';
      case MSG_TYPE.ERROR:
        return 'error-msg';
      default:
        return 'info-msg';
    }
  };

  return (
    <div className="product-slotter-container">
      <div className="product-slotter-header">
        <p className="title">{title}</p>
        <BrInputBox
          onEnter={onEnterHandler}
          value={userInput}
          onChange={inputBoxChangeHandler}
          onBlur={onEnterHandler}
        />
        {error && <p className="error-msg">{error}</p>}
        <p>Slot Position</p>
        {!error && <p className="grey-text">(in sequential lock range)</p>}
        {' '}
        {/** not sure why we have this **/}
      </div>
      <div className="product-slotter-grid-container">
        {Array(endPos - startPos + 1)
          .fill(null)
          .map((cell, index) => (
          /* eslint-disable */
            <div
              key={startPos + index}
              className={getGridItemClassName(startPos + index)}
              onClick={() => handleGridItemClick(startPos + index)}
              ref={
                selectedPosition === startPos + index
                  ? selectedGridItemRef
                  : null
              }
            >
              p
              {startPos + index}
            </div>
          /* eslint-enable */
          ))}
      </div>
      {message && (
        <div className="message-container">
          <p className={getMessageClassName()}>{message}</p>
        </div>
      )}
      <div className="product-slotter-grid-footer">
        <p className="action-btn" onClick={onCancel} role="presentation">
          {cancelText}
        </p>
        <p className="action-btn" onClick={() => onConfirm(selectedPosition)} role="presentation">
          {confirmText}
        </p>
      </div>
    </div>
  );
};

BrProductSlotter.propTypes = {
  seqLockRange: PropTypes.number,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func, // Returns you the position and not the index. (position = index + 1)
  title: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  currentItemIndex: PropTypes.number,
};

BrProductSlotter.defaultProps = {
  title: 'Edit Product Position',
  confirmText: 'Confirm',
  cancelText: 'Cancel',
};

export default BrProductSlotter;
